import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import styles from './strip.less'

import { DEFAULT_GRADIENT_COLOR } from 'shared/shared_consts'

class Strip extends React.Component {
  static propTypes = {
    stripRef: PropTypes.func,
    isResponsive: PropTypes.bool,
    isFullscreen: PropTypes.bool,
    staticHeight: PropTypes.number,
    backgroundImage: PropTypes.string,
    backgroundPan: PropTypes.number,
    gradientColor: PropTypes.string,
  }

  static defaultProps = {
    gradientColor: DEFAULT_GRADIENT_COLOR,
  }

  render() {
    let styleNames = []
    const responsiveStyle =
      this.props.isFullscreen && this.props.isResponsive
        ? 'responsive-fullscreen'
        : 'responsive'
    styleNames.push(this.props.isResponsive ? responsiveStyle : 'static')
    let customStyle = {}
    if (this.props.backgroundImage) {
      customStyle = {
        backgroundImage: `url(${this.props.backgroundImage})`,
        backgroundPosition: `50% ${this.props.backgroundPan}%`,
      }
      styleNames.push('strip-with-image')
    } else {
      customStyle = {
        height: this.props.staticHeight || '100%',
      }
      styleNames.push(
        `strip-${this.props.gradientColor || DEFAULT_GRADIENT_COLOR}`
      )
    }

    return (
      <div
        styleName={styleNames.join(' ')}
        className="strip"
        style={customStyle}
        ref={this.props.stripRef}
      />
    )
  }
}

export default cssModules(Strip, styles, { allowMultiple: true })
